import * as React from 'react';
import * as reviews from './style.module.scss';
import reviewsData from "./reviewsData.json";
import { TextReviews } from "../../../../../TextReviews";

export const Reviews = () => {
  return (
    <section className={reviews.reviews}>
      <div className="container">
        <h2 className={reviews.reviews__title}>
          Отзывы:
        </h2>
      </div>
      <TextReviews data={reviewsData}/>
    </section>
  );
};
